'use client';

import { T } from '@/i18n/LocaleProvider';
import { useState } from 'react';
import { MONO_FONT } from '@/theme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function FAQAccordion({ items = [], dark = false }) {
  const [open, setOpen] = useState(null);

  return (
    <Box>
      {items.map((item, i) => (
        <Box
          key={i}
          sx={{
            borderBottom: `1px solid ${dark ? '#1f2422' : '#e2e5e3'}`,
          }}
        >
          <Box
            component="button"
            onClick={() => setOpen(open === i ? null : i)}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              py: { xs: '20px', md: '24px' },
              textAlign: 'left',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              color: dark ? 'common.white' : 'text.primary',
              gap: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: 'clamp(16px, 1.2vw, 18px)',
                fontWeight: 500,
                lineHeight: 1.4,
                color: 'inherit',
              }}
            >
              <T>{item.q}</T>
            </Typography>
            <Box
              sx={{
                fontFamily: MONO_FONT,
                fontSize: '22px',
                lineHeight: 1,
                color: 'text.accent',
                flexShrink: 0,
                transform: open === i ? 'rotate(45deg)' : 'none',
                transition: 'transform 0.2s ease',
              }}
            >
              +
            </Box>
          </Box>

          {open === i && (
            <Box sx={{ pb: '28px', pr: { md: '64px' } }}>
              <Typography
                sx={{
                  fontSize: 'clamp(15px, 1.1vw, 17px)',
                  lineHeight: 1.75,
                  color: dark ? 'text.muted' : 'grey.600',
                }}
              >
                <T>{item.a}</T>
              </Typography>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
